import { render } from "./indexAnimate.vue?vue&type=template&id=a21d967c"
import script from "./indexAnimate.vue?vue&type=script&lang=js"
export * from "./indexAnimate.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__